import { Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import FileSaver from "file-saver";
import { CallApiGet } from '../../apicalls/calls';
import Paginate from '../Parts/Paginate';
import convertFromBase64 from "../../helpers/convertFromBase64";

const Comprobantes = () => {
    //#region STATE
    const [pageCount, setPageCount] = useState(0);
    const [currentItems, setCurrentItems] = useState([]);
    const [filterValues, setFilterValues] = useState({});
    const [loading, setLoading] = useState(false);
    const [files, setFiles] = useState([]);
    //#endregion

    const itemsPerPage = 10;

    const UsuarioS = JSON.parse(window.localStorage.getItem('usuario'));
    const { id_sorteo } = useParams();

    const closeModal = () => { 
        setCurrentItems([]); 
        $('#comprobantes').modal('hide');
    }

    const handlePageClick = async (e) => {
        await fetchRegistros(filterValues, e.selected * itemsPerPage);
    };

    const submitForm = async (values) => {
        const totalRegistros = await fetchRegistros(values, 0);
        setPageCount(Math.ceil(totalRegistros / itemsPerPage));
    }

    const fetchRegistros = async (values, offset) => {
        setLoading(true);
        let params = { id_usuario: UsuarioS.user.id, cliente: values.client, tipo_sorteo: values.type, id_sorteo: id_sorteo, offset: offset }
        const Call = await CallApiGet("getBitacoraDocumentos", params, UsuarioS.access_token);
        setCurrentItems(Call.success.data);
        setLoading(false);
        return Call.success.total_registros;
    }

    const handleDownload = async (folioCaptura) => {
        //console.log(folioCaptura);
        $("#backdrop").show();
        const resp = await CallApiGet('getTicketV2/' + folioCaptura, "", UsuarioS.access_token);
        if (resp.status != 200) {
            window.Swal.fire({
                icon: 'error',
                title: 'Error',
                text: "Ocurrió un error al generar el comprobante",
            });
            $("#backdrop").hide();
        } else {
            const tickets = resp.success.data.tickets ?? [];
            setFiles(tickets.map(t => {
                return convertFromBase64(t.stream);
            }));
            $("#backdrop").hide();
        }
    }

    useEffect(() => {
        if (files.length > 0) {
            window.Swal.fire({
                title: `¿Desea descargar los archivos?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (result.isConfirmed) {
                    files.forEach(file => FileSaver.saveAs(file));
                }
            });
        }
    }, [files]);    

    return (
        <div className="modal fade" id="comprobantes" onClick={() => setCurrentItems([])} tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-xl" onClick={e => e.stopPropagation() } style={{ maxWidth: "80vw" }} role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Mis comprobantes</h5>
                        <button type="button" onClick={closeModal} className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <Formik
                            initialValues={{
                                client: '',
                                type: 'TODOS'
                            }}
                            enableReinitialize="true"
                            onSubmit={(values) => {
                                setFilterValues(values);
                                submitForm(values);
                            }}>
                            {({
                                values,
                                handleChange,
                                handleSubmit
                            }) => (
                                <form onSubmit={handleSubmit} autoComplete="off" >
                                    <div className='row'>
                                        <div className="col-sm-4 col-md-4 col-lg-4">
                                            <div className="form-group">
                                                <label htmlFor="exampleInputEmail1">Cliente:</label>
                                                <input type="text" name='client' id="client" className='form-control form-control-sm' value={values.client} onChange={handleChange} />
                                            </div>
                                        </div>
                                        {/* <div className="col-sm-4 col-md-4 col-lg-4">
                                            <div className="form-group">
                                                <label htmlFor="exampleInputEmail1">Sorteo:</label>
                                                <select name="type" id="type" className='form-select form-select-sm' value={values.type} onChange={handleChange}>
                                                    <option value="TODOS">Seleccione uno</option>
                                                    <option value="1">Primer lugar</option>
                                                    <option value="2">Segundo lugar</option>
                                                </select>
                                            </div>
                                        </div> */}
                                        <div className="col-sm-4 col-md-4 col-lg-4">
                                            <div className="form-group" style={{ paddingTop: '30px' }}>
                                                <button type='submit' className='btn btn-sm mt-30 text-white' style={{ background: "#E6453B" }}>Buscar</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            )
                            }
                        </Formik>
                        <div className='table-responsive'>
                            <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                <thead>
                                    <tr>
                                        <th>Cliente</th>
                                        {/* <th>Tipo sorteo</th> */}
                                        <th>Fecha</th>
                                        <th>Descargar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading && (
                                        <tr className="w-100 text-center">
                                            <td colSpan={4}>
                                                <div className="spinner-border" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                    {!loading && currentItems.length == 0 && (
                                        <tr className='text-center'>
                                            <td colSpan={4}>No hay usuarios registrados.</td>
                                        </tr>
                                    )}
                                    {!loading && currentItems && currentItems.map((element, key) => {
                                        return <tr key={key}>
                                            <td>{element.cliente}</td>
                                          {/*   <td>{element.tipo_sorteo == 1 ? "Primer lugar" : "Segundo lugar"}</td> */}
                                            <td>{element.fecha}</td>
                                            <td className="text-center">
                                                <button className="btn btn-secondary btn-circle btn-sm" onClick={() => handleDownload(element.folio_captura)} data-bs-toggle="tooltip" data-bs-placement="top" title="Descargar ticket" ><i className="fa fa-download"></i></button>
                                            </td>
                                        </tr>
                                    })}
                                </tbody>
                            </table>
                        </div>
                        <div className='float-md-right'>
                            <Paginate handlePageClick={handlePageClick} pageCount={pageCount} />
                        </div>
                        {/* <RegistrosModal id_sorteo={id_sorteo} UsuarioS={UsuarioS} /> */}
                    </div>
                    <div className="modal-footer">
                        <button type="button" onClick={closeModal} className="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Comprobantes;